import { render, staticRenderFns } from "./RemoveGateway.vue?vue&type=template&id=5f2c38d2&scoped=true&"
import script from "./RemoveGateway.vue?vue&type=script&lang=js&"
export * from "./RemoveGateway.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGateway.vue?vue&type=style&index=0&id=5f2c38d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c38d2",
  null
  
)

export default component.exports